/* @flow */

import { LOCATION_CHANGE, CALL_HISTORY_METHOD } from 'react-router-redux'

import type { Alert, Action, RootState } from '../types'

export const STATE_KEY: string = 'alert'

export const SET_ALERT: string = 'opinary/SET_ALERT'
export const UNSET_ALERT: string = 'opinary/UNSET_ALERT'

export function setAlert(item: Alert): Action {
  return {
    type: SET_ALERT,
    item,
  }
}

export function unsetAlert(): Action {
  return {
    type: UNSET_ALERT,
  }
}

export function setAlertSuccess(message: string): Action {
  return setAlert({
    type: 'success',
    message,
  })
}

export function setAlertInfo(message: string): Action {
  return setAlert({
    type: 'info',
    message,
  })
}

export function setAlertDanger(message: string): Action {
  return setAlert({
    type: 'danger',
    message,
  })
}

export function setAlertDangerNotAllowed(): Action {
  return setAlertDanger(`
    you don't have permission to see this page.
    please log in with an account that has the required permissions
    and try again.
  `)
}

export function selectAlert(rootState: RootState): ?Alert {
  return rootState[STATE_KEY]
}

export default function reducer(
  state: ?Alert = null,
  action: {
    type: string,
    item: {
      type: string,
      message: string,
    },
  }
): ?Alert {
  switch (action.type) {
    case SET_ALERT:
      return action.item
    case UNSET_ALERT:
      return null
    // unset alert on change of browser location bar
    case LOCATION_CHANGE:
      return null
    // unset alert when routing through routerReducer
    case CALL_HISTORY_METHOD:
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/alert.js